'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeValidator = exports.joinValidators = exports.makeValueValidatorFromConfig = exports.makeValueValidator = exports.reduceErrorObjects = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// # Internals

/**
 * take a thing:
 * if it is an array, return that array.
 * if it is not an array, put it in an array.
 *
 * @param someThing - the thing to do it to
 * @returns {array}
 */
var ensureIsArray = function ensureIsArray(someThing) {
    return Array.isArray(someThing) ? someThing : [someThing];
};

/**
 * create one function that returns true if all of the provided functions return true
 *
 * @param {array} truthyFunctions
 * @returns {(any) => boolean}
 */
var combineTruthyFunctions = function combineTruthyFunctions(truthyFunctions) {
    return function (value) {
        return (0, _lodash.every)(truthyFunctions, function (func) {
            return func(value);
        });
    };
};

/**
 * combine string values from multiple objects into new object
 *
 * @param {object} previous
 * @param {object} next
 * @returns {object}
 */
var reduceErrorObjects = exports.reduceErrorObjects = function reduceErrorObjects(previous, next) {
    var errors = _extends({}, previous);

    (0, _lodash.toPairs)(next).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        if (value) {
            errors[key] = errors[key] ? errors[key] + ', ' + value : value;
        }
    });
    return errors;
};

/*
# Value Validators

Value validators will take a value and return errorMessage or undefined
 */

/**
 * create a single value validator function
 *
 * @param {string} message - error message to display should any of the truthyFunctions fail
 * @param {array} truthyFunctions - functions whose return value truthiness represents the validity of the input value
 * @returns {function}
 */
var makeValueValidator = exports.makeValueValidator = function makeValueValidator(message) {
    for (var _len = arguments.length, truthyFunctions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        truthyFunctions[_key - 1] = arguments[_key];
    }

    return function (value) {
        return combineTruthyFunctions(truthyFunctions)(value) ? undefined : message;
    };
};

/**
 * create a single value validator function from a configuration object
 *
 * @param {object} config - configuration object (described below)
 * @param {string} config.errorMessage - error message to display should this fail
 * @param {function|array} config.validator - truthy function or an array of them
 * @returns {function}
 *
 * EXAMPLE CONFIGS:
 *
 *    Single validator:
 *      {
 *          errorMessage: "Must be the word FOO",
 *          validator: (valueUnderTest) => ( valueUnderTest === 'FOO' )
 *      }
 *
 *    Multiple Validators:
 *      {
 *          errorMessage: "Must not be FOO or BAR",
 *          validator: [
 *              (valueUnderTest) => ( valueUnderTest !== 'FOO' ),
 *              (valueUnderTest) => ( valueUnderTest !== 'BAR' )
 *          ]
 *      }
 *
 */
var makeValueValidatorFromConfig = exports.makeValueValidatorFromConfig = function makeValueValidatorFromConfig(config) {
    return makeValueValidator.apply(undefined, [config.errorMessage].concat(_toConsumableArray(ensureIsArray(config.validator))));
};

/*
# Object Validators

Object validators will take an object ({key: value})
and return and object ({key: errorMessage or undefined})
 */

/**
 * creates an object validator function from multiple object validator functions
 *
 * @param {...function} validators
 * @returns {function}
 */
var joinValidators = exports.joinValidators = function joinValidators() {
    for (var _len2 = arguments.length, validators = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        validators[_key2] = arguments[_key2];
    }

    return function (values, props) {
        return validators.map(function (validate) {
            return validate(values, props);
        }).reduce(reduceErrorObjects);
    };
};

/**
 * create an object validator function from a configuration object
 *
 * @param {object} config - configuration object (described below)
 * @param {object|array} config.X - single value validator config object or objects
 * @returns {function}
 *
 * EXAMPLE CONFIGS:
 *
 *    single validator for a property:
 *
 *      {
 *          myFavoriteVariableName: {
 *              validator: (valueUnderTest) => ( valueUnderTest !== 'Foo' ),
 *              errorMessage: 'Foo is better'
 *          }
 *      }
 *
 *    multiple validators for a property:
 *
 *      {
 *          theWorstVariableName: [
 *              {
 *                  validator: (valueUnderTest) => ( valueUnderTest === 'Foo' ),
 *                  errorMessage: 'Foo cannot be the worst variable name.'
 *              },
 *              {
 *                  validator: (valueUnderTest) => ( valueUnderTest === 'Bar' ),
 *                  errorMessage: 'What kind of a monster are you?'
 *              }
 *          ]
 *      }
 */
var makeValidator = exports.makeValidator = function makeValidator(config) {
    var validators = (0, _lodash.chain)(config).toPairs().map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            fieldName = _ref4[0],
            fieldConfig = _ref4[1];

        return ensureIsArray(fieldConfig).map(function (validatorConfig) {
            var validator = makeValueValidatorFromConfig(validatorConfig);

            return function (values) {
                return _defineProperty({}, fieldName, validator(values[fieldName]));
            };
        });
    }).flattenDeep().value();

    return joinValidators.apply(undefined, _toConsumableArray(validators));
};